'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function StoryboardMapMediator(mapModel, storyboardController) {
	observable(this);
	const createScenesFromSelectedNodes = function () {
			mapModel.applyToActivated((nodeId) => {
				storyboardController.addScene(nodeId);
			});
		},
		createScenesFromSelectedNodesWithChildren = function () {
			mapModel.applyToActivated((nodeId) => {
				storyboardController.addScene(nodeId, false, 'with-children');
			});
		},
		editNode = function (nodeId) {
			const layoutNode = mapModel.getCurrentLayout()?.nodes[nodeId];
			if (!layoutNode) {
				return;
			}
			mapModel.focusAndSelect(nodeId);
			mapModel.editNode(nodeId);
		};
	Object.freeze(Object.assign(this, {createScenesFromSelectedNodes, createScenesFromSelectedNodesWithChildren, editNode}));
};
